import { ShareIcon } from '@heroicons/react/24/outline';

import { DialogTabsTrigger } from '@/components/core/Dialog';
import { Icon } from '@/components/core/Icon';
import { useTranslation } from '@/hooks/useTranslation';
import { PersistedItem } from '@/types/DataModel';

import { useItemHierarchies } from '../../hooks/useItemHierarchies';

const ItemHierarchiesTabTriggers = ({ item }: { item: PersistedItem }) => {

    const { t } = useTranslation();
    const { itemHierarchies } = useItemHierarchies(item);

    const getTitle = (hierarchy: string) => {
        const translatedHierarchyName = t(`hierarchy.${hierarchy}`);
        return t('ITEMSETTINGS.SHOW_HIERARCHY', { hierarchyName: translatedHierarchyName });
    };

    return (
        itemHierarchies.map(hierarchy =>
            <DialogTabsTrigger id={hierarchy} key={hierarchy} value={hierarchy} title={getTitle(hierarchy)} className='tw-flex tw-items-center tw-justify-center'>
                <Icon icon={ShareIcon} size="lg" variant="dark" />
            </DialogTabsTrigger>
        )
    );
};

export { ItemHierarchiesTabTriggers };
